import React, { useReducer, createContext } from "react";
import userReducer, { initialState } from "../reducers/userReducer";
import { UserContextType } from "../types/userTypes";

export const UserContext = createContext({} as UserContextType);

const UserProvider = (props: any) => {
  const [state, dispatch] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserProvider;
